import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeComponentProps as _mergeComponentProps, mergeProps as _mergeProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("change-location-drawer__drawercontent-0iygso", {
  overflowY: "auto",
  outline: "none"
});
const _staticStyles2 = _cssRef("change-location-drawer__drawercontentcontainer-22e6cv", {
  padding: "0 24px",
  "@media (max-width: 767px)": {
    padding: "0 16px"
  }
});
const _staticStyles3 = _cssRef("change-location-drawer__drawercontentactions-1mnfdp", {
  paddingTop: "24px",
  paddingBottom: "24px"
});
const _staticStyles4 = _cssRef("change-location-drawer__logoandcloseflex-25lqkf", {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  marginBottom: "16px",
  "@media (max-width: 767px)": {
    justifyContent: "flex-end"
  }
});
const _staticStyles5 = _cssRef("change-location-drawer__logocontainer-3ev529", {
  width: "100%",
  display: "block",
  maxWidth: "220px",
  "@media (max-width: 767px)": {
    display: "none"
  }
});
const _staticStyles6 = _cssRef("change-location-drawer__closebutton-3f13s2", {
  position: "relative"
});
const _staticStyles7 = _cssRef("change-location-drawer__backbuttoncontainer-2iirk3", {
  marginTop: "8px",
  marginBottom: "8px",
  "@media (max-width: 767px)": {
    display: "none"
  }
});
const _staticStyles8 = _cssRef("change-location-drawer__changelocationtext-3oleyr", {
  marginBottom: "20px"
});
const _staticStyles9 = _cssRef("change-location-drawer__franchisescontainer-22e6cv", {
  padding: "0 24px",
  "@media (max-width: 767px)": {
    padding: "0 16px"
  }
});
const _staticStyles0 = _cssRef("change-location-drawer__skeletonsrowset-1b6ycp", {
  padding: "24px 0",
  "@media (max-width: 767px)": {
    padding: "16px 24px"
  }
});
const _staticStyles1 = _cssRef("change-location-drawer__skeleton-0des7q", {
  minHeight: "67px"
});
const _staticStyles10 = _cssRef("change-location-drawer__searchboxcontainer-2ync7r", {
  background: "var(--system-grey-100)",
  padding: "0 24px",
  "@media (max-width: 767px)": {
    padding: "0 16px"
  }
});
const _staticStyles11 = _cssRef("change-location-drawer__searchboxcopy-1w8hfu", {
  borderRadius: "6px",
  color: "var(--system-black)",
  padding: "16px 0",
  fontSize: "14px",
  marginBottom: "8px",
  "@media (max-width: 767px)": {
    padding: "12px 0"
  }
});
const _staticStyles12 = _cssRef("change-location-drawer__nationalcallcenterrowset-1no0hc", {
  padding: "24px 0",
  "@media (max-width: 767px)": {
    padding: "16px 0"
  }
});
const _staticStyles13 = _cssRef("change-location-drawer__nationalcallcenterbuttoncontainer-0oa6fd", {
  maxWidth: "250px"
});
const _staticStyles14 = _cssRef("change-location-drawer__franchiseitemrowset-1no0hc", {
  padding: "24px 0",
  "@media (max-width: 767px)": {
    padding: "16px 0"
  }
});
const _staticStyles15 = _cssRef("change-location-drawer__franchisecontainer-201puq", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
});
const _staticStyles16 = _cssRef("change-location-drawer__franchisename-1ftx2f", {
  maxWidth: "50%",
  marginRight: "8px"
});
const _staticStyles17 = _cssRef("change-location-drawer__franchiseactions-12yk60", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  "@media (max-width: 767px)": {
    minWidth: "unset"
  }
});
const _staticStyles18 = _cssRef("change-location-drawer__franchiseselecttypography-3kjnfd", {
  padding: "8px 28px",
  backgroundColor: "var(--primary-orange-500)",
  color: "var(--system-white)",
  marginBottom: "8px",
  "@media (max-width: 1200px)": {
    padding: "8px 16px"
  }
});
import React from 'react';
import { useLocator } from '../../../contexts/franchise/locator-provider';
import FranchiseSearchInput, { SearchInputAddressComponents } from '../franchise-search-input';
import { PHONE_NUMBER, PHONE_NUMBER_DISPLAY, CHANGE_LOCATION } from '../../../constants';
import { toTelHref } from '../../utils/format-phone-link';
import useNearbyFranchises from '../../../hooks/use-nearby-franchises';
import { colors } from '../../primitives/colors';
import Divider from '../../primitives/divider';
import { Drawer, DrawerContent } from '../../primitives/drawer';
import RowSet from '../../primitives/grid/row-set';
import Skeleton from '../../primitives/skeleton';
import { StyledButtonAsLink } from '../../primitives/styled-button';
import StyledPillButton from '../../primitives/styled-pill-button';
import { borderRadius, breakpoints } from '../../primitives/tokens';
import Typography from '../../primitives/typography';
import { GeocoderReturnable } from '../../../api-utils/geocode';
import Container from '../../primitives/grid/container';
import CloseButton from '../../primitives/close-button';
import Logo from '../../primitives/logo';
import RatingSummary from './rating-summary';
interface ChangeLocationDrawerProps {
  visible: boolean;
  onClose: () => void;
}
const styles = {
  drawerContent: _staticStyles,
  drawerContentContainer: _staticStyles2,
  drawerContentActions: _staticStyles3,
  logoAndCloseFlex: _staticStyles4,
  logoContainer: _staticStyles5,
  closeButton: _staticStyles6,
  backButtonContainer: _staticStyles7,
  changeLocationText: _staticStyles8,
  franchisesContainer: _staticStyles9,
  skeletonsRowSet: _staticStyles0,
  skeleton: _staticStyles1,
  searchBoxContainer: _staticStyles10,
  searchBoxCopy: _staticStyles11,
  nationalCallCenterRowSet: _staticStyles12,
  nationalCallCenterButtonContainer: _staticStyles13,
  franchiseItemRowSet: _staticStyles14,
  franchiseContainer: _staticStyles15,
  franchiseName: _staticStyles16,
  franchiseActions: _staticStyles17,
  franchiseSelectTypography: _staticStyles18
};
const ChangeLocationDrawer = ({
  visible,
  onClose
}: ChangeLocationDrawerProps): JSX.Element => {
  const [query, setQuery] = React.useState<GeocoderReturnable | null>(null);
  // might be only relevant while we decide which location detection provider to use
  // gets the address the user entered when he ultimately selects a franchise
  const [userSelectedGeoLocation, setUserSelectedGeoLocation] = React.useState<SearchInputAddressComponents | null>(null);
  const {
    setFranchise,
    nearby,
    geo: locatorGeo
  } = useLocator();
  const {
    data: searchedFranchises,
    isLoading,
    announcements
  } = useNearbyFranchises(query && query.latitude && query.longitude ? {
    latitude: query.latitude,
    longitude: query.longitude,
    zip: query?.zip || null,
    locationType: query.locationType || null,
    country: query?.country || null,
    provider: 'SEARCH'
  } : null);

  // If no query has been made, use the franchises we already found via the locator
  const franchises = query ? searchedFranchises : nearby;
  return <Drawer open={visible} onOpenChange={() => {
    onClose();
  }}>
            <DrawerContent {..._mergeComponentProps({
      placement: "left",
      size: "xl",
      css: styles.drawerContent
    })}>
                <Container {..._mergeComponentProps({
        css: styles.drawerContentContainer
      })}>
                    <div {..._mergeProps({
          css: styles.drawerContentActions
        })}>
                        <div {..._mergeProps({
            css: styles.logoAndCloseFlex
          })}>
                            <div {..._mergeProps({
              css: styles.logoContainer
            })}>
                                <Logo role="img" aria-label="SERVPRO" />
                            </div>
                            <CloseButton {..._mergeComponentProps({
              css: styles.closeButton,
              onClick: onClose
            })} />
                        </div>
                        <div {..._mergeProps({
            css: styles.backButtonContainer
          })}>
                            <StyledPillButton onClick={onClose}>‹ Back</StyledPillButton>
                        </div>
                        <Typography {..._mergeComponentProps({
            fontSize: "lg",
            fontWeight: "medium",
            css: styles.changeLocationText
          })}>
                            {CHANGE_LOCATION}
                        </Typography>
                        <FranchiseSearchInput className="change-location-cta" value={query?.address || ''} onChange={address => {
            setQuery(address);
            setUserSelectedGeoLocation(address);
          }} />
                    </div>
                </Container>
                {!isLoading && announcements.filter(x => !!x.searchBoxCopy).map(({
        searchBoxCopy
      }) => <Container {..._mergeComponentProps({
        css: styles.searchBoxContainer
      })}>
                        <div {..._mergeProps({
          css: styles.searchBoxCopy,
          dangerouslySetInnerHTML: {
            __html: searchBoxCopy || ''
          }
        })} />
                    </Container>)}
                <Container {..._mergeComponentProps({
        css: styles.franchisesContainer
      })}>
                    {isLoading && Array.from(Array(5)).map((_, idx) => <React.Fragment
        /* eslint-disable-next-line react/no-array-index-key */ key={idx}>
                            <RowSet {..._mergeComponentProps({
            breakpoints: {
              dt: {
                between: 10
              }
            },
            css: styles.skeletonsRowSet
          })}>
                                <Skeleton {..._mergeComponentProps({
              css: styles.skeleton
            })} />
                            </RowSet>
                        </React.Fragment>)}
                    {!isLoading && franchises?.length === 0 && <RowSet {..._mergeComponentProps({
          breakpoints: {
            dt: {
              between: 10
            }
          },
          css: styles.nationalCallCenterRowSet
        })}>
                            <Typography fontSize={{
            tb: 'lg',
            dt: 'xl'
          }} fontWeight="bold">
                                SERVPRO National Call Center
                            </Typography>
                            <div {..._mergeProps({
            css: styles.nationalCallCenterButtonContainer
          })}>
                                <StyledButtonAsLink to={toTelHref(PHONE_NUMBER)}>
                                    {PHONE_NUMBER_DISPLAY}
                                </StyledButtonAsLink>
                            </div>
                        </RowSet>}
                    {!isLoading && franchises?.length > 0 && franchises.slice(0, 5).map(({
          data: franchiseData,
          isLoading: franchiseLoading
        }, idx) => {
          const {
            name,
            reviewSummary
          } = franchiseData || {};
          return (
            // eslint-disable-next-line react/no-array-index-key
            <React.Fragment key={idx}>
                                    <RowSet {..._mergeComponentProps({
                breakpoints: {
                  dt: {
                    between: 10
                  }
                },
                css: styles.franchiseItemRowSet
              })}>
                                        <Skeleton {..._mergeComponentProps({
                  css: styles.skeleton
                })}>
                                            {!franchiseLoading && <div {..._mergeProps({
                    css: styles.franchiseContainer
                  })}>
                                                    <Typography {..._mergeComponentProps({
                      fontSize: {
                        tb: 'lg',
                        dt: 'xl'
                      },
                      fontWeight: "bold",
                      css: styles.franchiseName
                    })}>
                                                        {name}
                                                    </Typography>
                                                    <div {..._mergeProps({
                      css: styles.franchiseActions
                    })}>
                                                        <Typography {..._mergeComponentProps({
                        fontSize: {
                          dt: 'base',
                          tb: 'sm'
                        },
                        fontWeight: "medium",
                        css: styles.franchiseSelectTypography
                      })}>
                                                            <button type="button" className="change-location-select-cta" onClick={() => {
                          /*
                          * 'userSelectedGeoLocation' might only
                          * be relevant while we decide which location
                          * detection provider to use
                          * */
                          if (franchiseData && userSelectedGeoLocation) {
                            // This condition is relevant when the user enters an address in the search box

                            setFranchise(franchiseData, userSelectedGeoLocation);
                            onClose();
                          } else if (franchiseData && locatorGeo) {
                            // This condition is relevant when a user has not entered an address in the search box,
                            // But we still show some nearby franchises anyway
                            setFranchise(franchiseData, {
                              latitude: locatorGeo.latitude,
                              longitude: locatorGeo.longitude,
                              city: locatorGeo.city,
                              state: locatorGeo.state,
                              stateShort: locatorGeo.stateShort,
                              zip: locatorGeo.zip || '',
                              country: locatorGeo.country
                            });
                            onClose();
                          }
                        }}>
                                                                Select This Location
                                                            </button>
                                                        </Typography>
                                                        {reviewSummary?.shouldDisplay && reviewSummary.rating != null && reviewSummary.count != null && <RatingSummary smallSize rating={reviewSummary.rating} count={reviewSummary.count} />}
                                                    </div>
                                                </div>}
                                        </Skeleton>
                                    </RowSet>
                                    <Divider />
                                </React.Fragment>
          );
        })}
                </Container>
            </DrawerContent>
        </Drawer>;
};
export default ChangeLocationDrawer;